const groups = [
  ['Regulatory', 'Applicable authorities and project-specific requirements'],
  ['Safety', 'International and national safety guidance'],
  ['Engineering codes', 'Applicable mechanical, electrical, and quality codes'],
  ['Nuclear standards', 'Relevant consensus standards and technical guidance'],
  ['Measurement', 'Traceability, calibration, and uncertainty standards'],
  ['Scientific data', 'Evaluated physical, nuclear, and material data'],
]

export function TechnologyReferences() {
  return <section className="tech-references" id="technical-references"><div className="container"><header><span className="tech-index">Technical references</span><h2>Technical basis,<br />clearly scoped.</h2><p>Reference categories are provided as an integration framework. Inclusion does not imply endorsement, approval, certification, or affiliation.</p></header><div className="tech-reference-grid">{groups.map(([name, copy], index) => <div key={name}><span>{String(index + 1).padStart(2, '0')}</span><strong>{name}</strong><p>{copy}</p></div>)}</div></div></section>
}
